import {IRegulationMenuItemFactory} from "./regulation-menu-item-factory.interface";
import {MenuItemKey} from "../../configurations/config-data-sections/generated-config-const";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {IMenuItemRenderer} from "../renderer/menu-item.renderer.interface";
import {IMenuItemConfigReader} from "../menu-item-config-reader/menu-item-config-reader.interface";
import {IMenuItemActionFactoryService} from "../../menu-item-action-factory/menu-item-action-factory.service.interface";

export class RegulationMenuItemFactoryBase implements IRegulationMenuItemFactory {
    constructor(protected readonly services: IServiceFactoryExtended) {
    }

    getSideMenuItem(key: MenuItemKey, configReader: IMenuItemConfigReader, menuItemActionFactory: IMenuItemActionFactoryService): IMenuItemRenderer | null {
        return null;
    }

    getCrossBrandsAboveSearchItem(key: MenuItemKey, configReader: IMenuItemConfigReader, menuItemActionFactory: IMenuItemActionFactoryService): IMenuItemRenderer | null {
        return null;
    }
    getBottomNavBarMenuItem(key: MenuItemKey, configReader: IMenuItemConfigReader, menuItemActionFactory: IMenuItemActionFactoryService): IMenuItemRenderer | null {
        return null;
    }

    getUsefulLinksMenuItem(key: MenuItemKey, configReader: IMenuItemConfigReader, menuItemActionFactory: IMenuItemActionFactoryService): IMenuItemRenderer | null {
        return null;
    }

    getUserMenuItem(key: MenuItemKey, configReader: IMenuItemConfigReader, menuItemActionFactory: IMenuItemActionFactoryService): IMenuItemRenderer | null {
        return null;
    }

    getAppHeaderMenuItem(key: MenuItemKey, configReader: IMenuItemConfigReader, menuItemActionFactory: IMenuItemActionFactoryService): IMenuItemRenderer | null {
        return null;
    }

    getHomepageHeaderArenaMenuItem(key: MenuItemKey, configReader: IMenuItemConfigReader, menuItemActionFactory: IMenuItemActionFactoryService): IMenuItemRenderer | null {
        return null;
    }

}